alt = require 'alt'
EtdActions = require 'actions/etd_actions'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'
Translation = require 'components/mixins/translation'
OptionsList = require 'components/common/options_list'
DialogBoxMixin = require 'components/mixins/dialog_box_mixin'
RankingJudgement = require 'components/etd/judgements/ranking_judgement'
RankingJudgementV2 = require 'components/etd/judgements/ranking_judgement_v2'
JudgementTable = require 'components/etd/judgements/judgement_table'
RegularJudgment = require 'components/etd/judgements/regular_judgment'
Confirmation = require 'components/common/confirmation'
{ bool, func, instanceOf, string, number } = PropTypes

JudgementComponent = createReactClass
  displayName: 'JudgementComponent'

  propTypes:
    className: PropTypes.string
    criterion: PropTypes.instanceOf(Immutable.Map).isRequired
    criticalOutcomes: PropTypes.instanceOf(Immutable.List)
    editable: PropTypes.bool.isRequired
    highlightAsDiff: PropTypes.bool
    highlighted: PropTypes.bool
    isConsensus: PropTypes.bool
    noAutoSave: PropTypes.bool
    onEditClick: PropTypes.func
    onJudgementChange: PropTypes.func
    overarchingQuestionData: PropTypes.instanceOf(Immutable.Map)
    parentSectionsData: PropTypes.instanceOf(Immutable.List)
    qualityIndicators: PropTypes.instanceOf(Immutable.List)
    questionType: PropTypes.string.isRequired
    readOnly: PropTypes.bool
    renderMode: PropTypes.string
    sectionData: PropTypes.instanceOf(Immutable.Map).isRequired
    sectionId: PropTypes.string.isRequired
    sectionName: PropTypes.string.isRequired
    selectedOption: PropTypes.string
    showJudgement: PropTypes.bool
    templateId: PropTypes.string.isRequired
    type: PropTypes.oneOf(['overarching', 'keyMessages', 'regular', 'qualityIndicators'])

  getDefaultProps: ->
    className: ''
    highlightAsDiff: false
    isConsensus: false
    noAutoSave: false
    overarchingQuestionData: Immutable.Map()
    parentSectionsData: Immutable.List()
    qualityIndicators: Immutable.List()
    renderMode: 'regular'
    rowSpan: 1
    type: 'regular'

  mixins: [
    CustomRenderMixin
    Translation('es:recommendations.table')
    DialogBoxMixin
  ]

  clearOptions: (evt)->
    return unless @props.editable
    evt.persist() # React-related. To access the event properties in an asynchronous way
    props =
      options: [
          text: @i18n 'judgement_clear_factor'
          actionCbk: =>
            @closeDialogBox()
            @clearJudgement()
        ,
          text: @i18n 'judgement_clear_all'
          actionCbk: =>
            @closeDialogBox()
            @clearAllJudgementsAction(evt)
      ]
    @showInDialogBox evt, OptionsList, props, 'soj-options-list-dialog'
    evt.preventDefault()

  clearJudgement: ->
    EtdActions.clearJudgement @props.sectionId, @props.isConsensus
    EtdActions.save() unless @props.noAutoSave

  clearAllJudgementsAction: (evt)->
    props =
      onCancel: @closeDialogBox
      onConfirm: =>
        @closeDialogBox()
        EtdActions.clearAllJudgements @props.isConsensus
        EtdActions.save() unless @props.noAutoSave
      question: @i18n 'confirm_judgement_clear'
    @showInDialogBox evt, Confirmation, props, 'confirmation-modal soj-clear-dialog'

  render: ->
    {
      criterion
      criticalOutcomes
      editable
      isConsensus
      noAutoSave
      onJudgementChange
      overarchingQuestionData
      parentSectionsData
      qualityIndicators
      questionType
      readOnly
      renderMode
      sectionData
      sectionId
      sectionName
      selectedOption
      templateId
      type
    } = @props

    rating = criterion.get('rating', Immutable.Map())
    isRating = sectionData.get('rating', false) or sectionData.get('perIntervention', false)
    useJudgmentTable = sectionData.get('perOutcomes', false) or not
      sectionData.get('parentSections', Immutable.List()).isEmpty()
    isStarRating = templateId in ['overarchingDx-testCrPp', 'overarchingTx-crPp', 'qualityIndicators']

    <div onContextMenu={@clearOptions}>
      {if isRating and isStarRating
        <RankingJudgement
          criterion={criterion}
          editable={editable}
          qualityIndicators={qualityIndicators}
          overarchingQuestionData={overarchingQuestionData}
          questionType={questionType}
          rating={rating}
          renderMode={renderMode}
          sectionId={sectionId}
          type={type}
        />
      else if isRating
        <RankingJudgementV2
          criterion={criterion}
          editable={editable}
          overarchingQuestionData={overarchingQuestionData}
          questionType={questionType}
          renderMode={renderMode}
          sectionId={sectionId}
        />
      else if useJudgmentTable
        <JudgementTable
          criterion={criterion}
          editable={editable}
          readOnly={readOnly}
          overarchingQuestionData={overarchingQuestionData}
          parentSectionsData={parentSectionsData}
          questionType={questionType}
          renderMode={renderMode}
          sectionId={sectionId}
          templateId={templateId}
        />
      else
        <RegularJudgment
          criterion={criterion}
          criticalOutcomes={criticalOutcomes}
          editable={editable}
          isConsensus={isConsensus}
          noAutoSave={noAutoSave}
          onJudgementChange={onJudgementChange}
          questionType={questionType}
          readOnly={readOnly}
          renderMode={renderMode}
          sectionId={sectionId}
          sectionName={sectionName}
          selectedOption={selectedOption}
          templateId={templateId}
        />
      }
    </div>

module.exports = JudgementComponent
